import { useI18n } from 'vue-i18n';
import { onload } from '@/utils/tools';
import { ready as uniframeReady } from '@/hooks/uniframe';
import { error as errorToast } from '@/utils/toast';

export function useTransfer() {
    const { t } = useI18n();
    const init = () => {
        uniframeReady().then(() => {
            window.BybitUniFrame.ready(({ transfer }) => {
                const {
                    THEME, VISIBILE, PATH_NAME,
                } = transfer.properties;
                const { HIDE_MODAL, TRANSFER_COMPLETE, TRANSFER_FAIL } = transfer.events;
                // const supportAccount = ['contract', 'spot', 'finacial', 'option', 'fiat', 'unified']; // 同资产页划转一样
                transfer.init().then(() => {
                    transfer
                        .setProperty(THEME, 'light')
                        .setProperty(PATH_NAME, 'spotLoan');

                    transfer
                        .subscribeEvent(HIDE_MODAL, () => {
                            transfer.setProperty(VISIBILE, false);
                        })
                        .subscribeEvent(TRANSFER_COMPLETE, () => {
                            transfer.setProperty(VISIBILE, false);
                        })
                        .subscribeEvent(TRANSFER_FAIL, () => {
                            errorToast(t('currentOperationFailed'));
                        });
                });
            });
        });
    };

    const visible = (coin = '', isUTA = false, pledgeAccount = '') => {
        uniframeReady().then(() => {
            window.BybitUniFrame.ready(({ transfer }) => {
                const {
                    VISIBILE, COIN, DEFAULT_TO, DEFAULT_FROM,
                } = transfer.properties;

                const accountEnum = {
                    // 统保账户
                    UNIFIED: 'ACCOUNT_TYPE_UNIFIED',
                    // 现货账户
                    SPOT: 'ACCOUNT_TYPE_SPOT',
                    // 通用账户（合约账户）
                    CONTRACT: 'ACCOUNT_TYPE_CONTRACT',
                    // 资金账户
                    FUND: 'ACCOUNT_TYPE_FUND',
                };
                // 1-现货账户
                // 5-资金帐户
                // 6-UTA
                let fromAccount = '';
                let toAccount = '';

                if (pledgeAccount === 5) {
                    // 选择资金账户
                    // "从"选中账户为UTA或现货账户
                    fromAccount = isUTA ? accountEnum.UNIFIED : accountEnum.SPOT;
                    // "到"选中账户为资金账户
                    toAccount = accountEnum.FUND;
                }

                if (pledgeAccount === 1) {
                    // 选择现货账户
                    // "从"选中账户为资金账户
                    fromAccount = accountEnum.FUND;
                    // 到"选中账户为现货账户
                    toAccount = accountEnum.SPOT;
                }

                if (pledgeAccount === 6) {
                    // 选择UTA账户
                    // "从"选中账户为资金账户
                    fromAccount = accountEnum.FUND;
                    // "到"选中账户为UTA账户
                    toAccount = accountEnum.UNIFIED;
                }

                transfer
                    .setProperty(COIN, coin)
                    .setProperty(DEFAULT_FROM, fromAccount) // 如果是统保账户默认为统保账户
                    .setProperty(DEFAULT_TO, toAccount)
                    .setProperty(VISIBILE, true);
            });
        });
    };

    onload().then(() => {
        init();
    });

    return {
        init,
        visible,
    };
}
